<template>
  <section id="lokalizacja" class="location section">
    <div class="container">
      <div class="section-header" data-aos="fade-up">
        <h2>Obszar Działania</h2>
        <div class="section-line"></div>
        <p>Świadczymy usługi na terenie Warszawy i okolic</p>
      </div>
      
      <div class="location-content">
        <div class="location-info" data-aos="fade-right">
          <div class="company-info">
            <h3>VI-GAS Autoryzowany Serwis Viessmann</h3>
            
            <div class="info-item">
              <strong>📞 Telefon:</strong>
              <p><a href="tel:+48570422020">+48 570 420 020</a></p>
            </div>
            <div class="info-item">
              <strong>✉️ Email:</strong>
              <p><a href="mailto:kontakt@vi-gas.pl">kontakt@vi-gas.pl</a></p>
            </div>
          </div>
          
          <div class="service-areas">
            <h4>Obsługiwane obszary:</h4>
            <ul>
              <li>Warszawa i dzielnice</li>
              <li>Pruszków</li>
              <li>Piaseczno</li>
              <li>Legionowo</li>
              <li>Marki</li>
              <li>Ząbki</li>
              <li>Do 50 km od Warszawy</li>
            </ul>
          </div>
        </div>
        
        <div class="map-container" data-aos="fade-left">
          <div id="map" ref="mapContainer" class="map"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  name: 'LocationSection',
  setup() {
    const mapContainer = ref(null)
    
    onMounted(() => {
      // Initialize map
      const map = L.map(mapContainer.value).setView([52.2297, 21.0122], 11)
      
      // Add tile layer
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(map)
      
      // Company location
      const companyLocation = [52.2297, 21.0122] // Warsaw coordinates
      
      // Add company marker
      const companyIcon = L.divIcon({
        html: '<div class="custom-marker company-marker">🏢</div>',
        className: 'custom-div-icon',
        iconSize: [30, 30],
        iconAnchor: [15, 15]
      })
      
      L.marker(companyLocation, { icon: companyIcon })
        .addTo(map)
        .bindPopup('<b>VI-GAS</b><br>ul. Gliwicka 3, Warszawa')
      
      // Add service radius circle
      L.circle(companyLocation, {
        color: '#FF6B35',
        fillColor: '#FF6B35',
        fillOpacity: 0.1,
        radius: 50000 // 50km radius
      }).addTo(map).bindPopup('Obszar działania - 50km')
      
      // Add markers for service areas
      const serviceAreas = [
        { name: 'Pruszków', coords: [52.1645, 20.8081] },
        { name: 'Piaseczno', coords: [52.0754, 21.0225] },
        { name: 'Legionowo', coords: [52.4056, 20.9297] },
        { name: 'Marki', coords: [52.3147, 21.1053] },
        { name: 'Ząbki', coords: [52.2953, 21.0989] }
      ]
      
      serviceAreas.forEach(area => {
        const areaIcon = L.divIcon({
          html: '<div class="custom-marker area-marker">📍</div>',
          className: 'custom-div-icon',
          iconSize: [20, 20],
          iconAnchor: [10, 10]
        })
        
        L.marker(area.coords, { icon: areaIcon })
          .addTo(map)
          .bindPopup(`<b>${area.name}</b><br>Obsługiwany obszar`)
      })
    })
    
    return {
      mapContainer
    }
  }
}
</script>

<style lang="scss" scoped>
.location {
  background: #f8f9fa;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    margin: 0 auto 20px;
    border-radius: 2px;
  }
  
  p {
    font-size: 1.1rem;
    color: #666;
  }
}

.location-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.location-info {
  .company-info {
    background: white;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
    
    h3 {
      color: #FF6B35;
      margin-bottom: 20px;
      font-size: 1.3rem;
    }
    
    .info-item {
      margin-bottom: 15px;
      
      strong {
        display: block;
        margin-bottom: 5px;
        color: #333;
      }
      
      p {
        margin: 0;
        color: #666;
        
        a {
          color: #FF6B35;
          text-decoration: none;
          
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  
  .service-areas {
    background: white;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    
    h4 {
      color: #333;
      margin-bottom: 20px;
      font-size: 1.2rem;
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        padding: 8px 0;
        color: #666;
        border-bottom: 1px solid #eee;
        
        &:last-child {
          border-bottom: none;
        }
        
        &:before {
          content: '✓';
          color: #FF6B35;
          font-weight: bold;
          margin-right: 10px;
        }
      }
    }
  }
}

.map-container {
  .map {
    height: 500px;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
}

:global(.custom-marker) {
  font-size: 20px;
  text-align: center;
  line-height: 1;
  
  &.company-marker {
    font-size: 24px;
  }
  
  &.area-marker {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .location-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .map-container .map {
    height: 400px;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
}
</style>